import React from 'react'
import ItemSection from './components/itemSection'
import Money from 'uiComponents/money'
import { IOrderItemOption } from 'orders/schema'
import { Trans, useTranslation } from 'translations'

const ItemOptionsSection = ({
    options,
    isItemSelected,
    accountSlug,
    isItemCanceledRefunded,
    shouldShowPricesWithoutTax,
}: {
    options: IOrderItemOption[]
    isItemSelected: boolean
    accountSlug: string
    isItemCanceledRefunded: boolean
    shouldShowPricesWithoutTax: boolean
}) => {
    const { t } = useTranslation()
    const totalPrice = React.useMemo(() => {
        return options.reduce((acc, option) => acc + Number(option.priceInclTax), 0)
    }, [options])

    return (
        <ItemSection
            sectionName={
                <Trans
                    i18nKey="orders.orders.orderDetails.itemOptions.title"
                    components={{ money: <Money amount={totalPrice} accountSlug={accountSlug} /> }}
                />
            }
            isItemSelected={isItemSelected}
            isItemCanceledRefunded={isItemCanceledRefunded}
        >
            <div className="item-options-content">
                <div className="content-row">
                    <h6 className="content-column start">{t('orders.orders.orderDetails.itemOptions.name')}</h6>
                    <h6 className="content-column center">{t('orders.orders.orderDetails.itemOptions.quantity')}</h6>
                    {shouldShowPricesWithoutTax && <h6 className="content-column end">{t('orders.orders.orderDetails.itemOptions.tax')}</h6>}
                    <h6 className="content-column end">{t('orders.orders.orderDetails.itemOptions.subtotal')}</h6>
                </div>
                {options.map((option, index) => (
                    <div key={index} className="content-row">
                        <span className="content-column start body1 light">{option.name}</span>
                        <span className="content-column center body1 light">{option.numberOfItems}</span>
                        {shouldShowPricesWithoutTax && (
                            <span className="content-column end body1 light">
                                <Money
                                    amount={Number(option.priceInclTax) - Number(option.priceExclTax)}
                                    accountSlug={accountSlug}
                                />
                            </span>
                        )}
                        <span className="content-column end body1 light">
                            <Money
                                amount={shouldShowPricesWithoutTax ? option.priceExclTax : option.priceInclTax}
                                accountSlug={accountSlug}
                            />
                        </span>
                    </div>
                ))}
                <div className="separator" />
                <div className="content-column total-price">
                    <span className="body1 bold">{t('orders.orders.orderDetails.items.total')}</span>
                    <span className="body1">
                        <Money amount={totalPrice} accountSlug={accountSlug} />
                    </span>
                </div>
            </div>
        </ItemSection>
    )
}

export default ItemOptionsSection
